import React from "react";
import { PlanShift } from "./index";
import { RosterAccessGate } from "./RosterAccessGate";

// The actual route-level component (routes.js's /teamzone/plan-shift entry)
// — composed here rather than inside PlanShift/index.js itself, since that
// same export is also used bare by Administration's own
// /administration/department/plan-shift route, which this gate must not
// affect.
export const TeamWorkspaceRoster = () => (
  <RosterAccessGate>
    <PlanShift />
  </RosterAccessGate>
);
